// extracted by mini-css-extract-plugin
module.exports = {"calendar":"appointments__Calendar__calendar","calendarDay":"appointments__Calendar__calendarDay"};